(function() { window.GUID_f71e4742_a7aa_4671_93f1_5de10e72847d = { getGuid: function() { return "f71e4742-a7aa-4671-93f1-5de10e72847d"; } }; })();
var CS;
(function (CS) {
    var Account;
    (function (Account) {
        function ShowValidateUserPopup(validateOnlyPassword, callback, onRefreshLayout = null) {
            var me = this;
            var popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'ValidateUserPopup',
                Url: CSParameters.BaseUrl + 'Account/ValidateUser/',
                Data: { validateOnlyPassword: validateOnlyPassword },
                Async: false,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPopupPositioned = function () {
                if (onRefreshLayout != null) {
                    onRefreshLayout(popup);
                }
            };
            popup.OnPosted = function (result) {
                callback(popup, $('#user_Password', popup.Content).val(), $('#user_Email', popup.Content).val());
            };
        }
        Account.ShowValidateUserPopup = ShowValidateUserPopup;
    })(Account = CS.Account || (CS.Account = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ValidateUser.js.map
